module.exports = __webpack_public_path__ + "img/parthner-4.7c569945.svg";